import { createBrowserRouter } from 'react-router-dom';
import ErrorPage from 'pages/common/ErrorPage/ErrorPage';
import { ProtectedRoute } from 'router/ProtectedRoute/ProtectedRoute';
import { AccessRoles } from 'shared/auth';
import Root from './routes/Root';
import Calculator from './routes/Calculator';
import routes from './routes';
import Czechia from '../pages/calculator/Czechia/Czechia';
import Slovakia from '../pages/calculator/Slovakia/Slovakia';
import Hungary from '../pages/calculator/Hungary/Hungary';

const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <ErrorPage />,
    element: <Root />,
    children: [
      {
        path: '/',
        element: <Calculator />,
        children: [
          {
            path: routes.czechia,
            element: (
              <ProtectedRoute
                allowedRoles={[
                  AccessRoles.FULL_ACCESS,
                  AccessRoles.ONLINE_CAMPAIGNS,
                ]}
              >
                <Czechia />
              </ProtectedRoute>
            ),
          },
          {
            path: routes.slovakia,
            element: (
              <ProtectedRoute
                allowedRoles={[
                  AccessRoles.FULL_ACCESS,
                  AccessRoles.ONLINE_CAMPAIGNS,
                ]}
              >
                <Slovakia />
              </ProtectedRoute>
            ),
          },
          {
            path: routes.hungary,
            element: (
              <ProtectedRoute
                allowedRoles={[
                  AccessRoles.FULL_ACCESS,
                  AccessRoles.ONLINE_CAMPAIGNS,
                ]}
              >
                <Hungary />
              </ProtectedRoute>
            ),
          },
          // {
          //   path: routes.balticCountries,
          //   element: (
          //     <ProtectedRoute
          //       allowedRoles={[
          //         AccessRoles.FULL_ACCESS,
          //         AccessRoles.ONLINE_CAMPAIGNS,
          //       ]}
          //     >
          //       <BalticCountries />
          //     </ProtectedRoute>
          //   ),
          // },
          // {
          //   path: routes.fairValue,
          //   element: (
          //     <ProtectedRoute
          //       allowedRoles={[AccessRoles.FULL_ACCESS, AccessRoles.FAIR_VALUE]}
          //     >
          //       <FairValue />
          //     </ProtectedRoute>
          //   ),
          // },
          // {
          //   path: routes.digitalFairValue,
          //   element: (
          //     <ProtectedRoute
          //       allowedRoles={[
          //         AccessRoles.FULL_ACCESS,
          //         AccessRoles.DIGITAL_FAIR_VALUE,
          //       ]}
          //     >
          //       <DigitalFairValue />
          //     </ProtectedRoute>
          //   ),
          // },
        ],
      },
    ],
  },
]);

export default router;
